import { logError } from '../errors/error';
import React from 'react';
import ReactDom from "react-dom";
import './index.css';
import { Provider } from 'react-redux';
import store from '../../../store/index';
import { IdeEnum } from "../../../models/IdeEnum";
import DynamicMessage from '../UI/Popups/DynamicMessage/DynamicMessage';
import { DynamicMessageTypeEnum } from '../models/DynamicMessageTypeEnum';

const ideWrapperState = {
    projectFileUrl: null,
    iframeElem: null,
    saveDisable: false, // init with true untill load complete
    timeLastSave: null,
    ideConfig: null,
    loadIdeFirstFlag: false,
    lang: 'he',
    saveCallback: null,
    loadEndCB: null,
    projectId: null,
    changesCallBack: null,
    ideId: null
}

function load(projectFileUrl, iframeElem, ideUrl, ideConfig, lang, ideId = null, share = false, loadEndCB, projectId = null) {

    ideWrapperState.projectFileUrl = projectFileUrl; // pass null if its new project
    ideWrapperState.iframeElem = iframeElem;
    ideWrapperState.ideConfig = ideConfig;
    ideWrapperState.loadIdeFirstFlag = false;
    ideWrapperState.saveDisable = true;
    ideWrapperState.lang = lang;
    ideWrapperState.ideId = ideId
    ideWrapperState.loadEndCB = loadEndCB;
    ideWrapperState.projectId = projectId;
    if (ideWrapperState.iframeElem && ideWrapperState.iframeElem.style) {
        ideWrapperState.iframeElem.style.display = 'block';
    }
    if (!ideUrl.includes("?"))
        ideUrl = ideUrl + "?"
    if (share) {
        ideUrl = ideUrl + "&share=true&"
    }
    if (ideConfig) {
        Object.keys(ideConfig).forEach(key => ideUrl = `${ideUrl}${key}=${ideConfig[key]}&`)
    }
    iframeElem.setAttribute("allow", "camera;microphone")
    iframeElem.setAttribute("src", `${ideUrl}lang=${lang}`)

    // iframeElem.setAttribute("src", `${ideUrl}lang=en`)
}

const messageListener = (event) => {
    switch (event.data.action) {
        case "response-project-save":
            responseSaveProject(event.data);
            break;
        case "response-project-load":
            responseLoadProject(event.data);
            break;
        case "response-num-changes":
            responseNumChanges(event.data)
        case "platform-ready": // one time per load 
            if (!ideWrapperState.loadIdeFirstFlag) {
                ideWrapperState.loadIdeFirstFlag = true;
                requestLoadProject(event.data);
            }
            break;
        default:
            break;
    }
}

if (!window.ideWrapperAddMessageListener) {
    window.ideWrapperAddMessageListener = true;
    window.addEventListener("message", messageListener);
}

export const showToastMesssage = (color, text, closeCB) => {
    const elem = document.createElement("div");
    elem.innerHTML = text;
    elem.style.backgroundColor = color;
    elem.classList.add("ide-wrapper-toast-message");
    document.body.appendChild(elem);
    setTimeout(() => {
        document.body.removeChild(elem);
        if (closeCB)
            closeCB();
    }, 2800)
}

export const showDynamicMessage = (title, confirmText, content) => {
    if (localStorage.getItem("reloadCount") === null) {
        localStorage.setItem("reloadCount", 0)
    }
    if (Number(localStorage.getItem("reloadCount")) === 0) {
        localStorage.setItem("reloadCount", 1)
        createDynamicMessageElement(title, confirmText, content, false, () => { document.location.reload(true) })
    }
    else {
        createDynamicMessageElement(title, "הבנתי", content, true,
            () => {
                ideWrapperState.iframeElem.style.display = 'contents';
                document.getElementById('messagePopup').style.display = 'none';
                localStorage.removeItem("reloadCount")
            })
    }
}

const createDynamicMessageElement = (title, confirmText, content, showRestore, confirmFunc) => {
    const elem = document.createElement("div");
    elem.setAttribute('id', 'messagePopup');
    document.body.appendChild(elem);
    ReactDom.render(
        <Provider store={store}>
            <DynamicMessage
                type={DynamicMessageTypeEnum.Warn}
                title={title}
                content={content}
                confirmFunc={confirmFunc}
                confirmText={confirmText}
                showCancel={false}
                showRestore={showRestore} />
        </Provider>, document.getElementById('messagePopup'));
}

const requestSaveProject = (callback) => {
    if (ideWrapperState.iframeElem) {
        if (ideWrapperState.saveDisable) {
            showToastMesssage("red", "אנחנו באמצע יש להמתין")
        }
        else {
            // start save 
            ideWrapperState.saveCallback = callback;
            ideWrapperState.saveDisable = true;
            ideWrapperState.iframeElem.contentWindow.postMessage({ action: "request-save-project" }, "*");
        }
    }
}

const requestChangesProject = (callback) => {
    ideWrapperState.changesCallBack = callback
    if (ideWrapperState.ideId != IdeEnum.Scratch && ideWrapperState.ideId != IdeEnum.Edubot)
        callback(true)
    else
        ideWrapperState.iframeElem.contentWindow?.postMessage({ action: "request-num-changes" }, "*");
}

export const responseNumChanges = async (data) => {
    if (!data.error) {
        if (ideWrapperState.changesCallBack) {
            ideWrapperState.changesCallBack(data.changes)
        }
    }
    else {
        console.log("error err");
    }
}

const responseSaveProject = async (data) => {
    if (!data.error) {
        if (ideWrapperState.saveCallback) {
            ideWrapperState.saveCallback(new File([data.content], `project.${mapTypeToExtention[data.content.type]}`), data.thumbnail, null)
        }
        // temp download file instead of fetch to api 
        // var a = document.createElement("a");
        // document.body.appendChild(a);
        // a.style = "display: none";
        // const url = window.URL.createObjectURL(data.content);
        // a.href = url;
        // a.download = `ide-wrapper-file.${mapTypeToExtention[data.content.type]}`;
        // a.click();
        // window.URL.revokeObjectURL(url);
        enableSave()
    }
    else {
        console.error(data.error)
        try {
            logError(data.error, "ארעה תקלה בשמירת הפרויקט נסה שוב מאוחר יותר", "ideWrapper save project failed ", "ide-wrapper/index.js", 108)
        }
        catch (e1) { }
        showDynamicMessage("משהו השתבש בטעינת הפרויקט", "טען מחדש");
        if (ideWrapperState.saveCallback) {
            ideWrapperState.saveCallback(null, null, data.error)
        }
    }
}

const mapTypeToExtention = {
    "application/zip": "zip",
    "application/octet-stream": "hex",
    "application/x.scratch.sb3": "sb3",
    "application/json": "json"
}

const requestLoadProject = async () => {
    if (ideWrapperState.projectFileUrl) {
        try {
            const res = await fetch(ideWrapperState.projectFileUrl);
            const blob = await res.blob();
            let split = ideWrapperState.projectFileUrl.split(".");
            let ext = split[split.length - 1];
            const file = new File([blob], `ide-wrapper-file.${ext}`);
            if (ideWrapperState.projectId)
                ideWrapperState.iframeElem.contentWindow.postMessage({ action: "request-load-project", file: file, projectId: ideWrapperState.projectId }, "*");
            else
                ideWrapperState.iframeElem.contentWindow.postMessage({ action: "request-load-project", file: file }, "*");
        }
        catch (e) {
            try {
                logError(e, "ארעה תקלה בטעינת הפרויקט נסה שוב מאוחר יותר", "ideWrapper load project failed " + e.message, "ide-wrapper/index.js", 136)
            }
            catch (e1) { }
            console.error(e)
            showDynamicMessage("משהו השתבש בטעינת הפרויקט", "טען מחדש");
        }
    }
    else { // in new project case
        enableSave();
    }
}

const responseLoadProject = (data) => {
    if (!data.error) {
        // showToastMesssage("green", "הפרויקט נטען בהצלחה", enableSave)
        enableSave();
    }
    else {
        try {
            logError(data.error, "ארעה תקלה בטעינת הפרויקט נסה שוב מאוחר יותר", "ideWrapper load project failed", "ide-wrapper/index.js", 155)
        }
        catch (e1) { }
        console.error(data.error)
        showDynamicMessage("משהו השתבש בטעינת הפרויקט", "טען מחדש");
    }
    ideWrapperState.loadEndCB && ideWrapperState.loadEndCB({ error: data.error })
}

const enableSave = () => {
    ideWrapperState.saveDisable = false;
}

export {
    load,
    requestSaveProject,
    requestChangesProject
}

